import React from 'react';

const Calendar = () => {
  return (
    <div>
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Calendar</h2>
      <div className="bg-white rounded-lg shadow-sm p-8">
        <p className="text-gray-600">Calendar interface coming soon...</p>
      </div>
    </div>
  );
};

export default Calendar;